<template>
  <!-- 用户接待小结 -->
  <div class="reception-summary">
    <van-nav-bar
      title="用户接待小结"
      left-arrow
      @click-left="$router.back()"
    ></van-nav-bar>
    <div class="form">
      <van-form ref="formRef" @submit.prevent>
        <van-cell title="用户编号：" :value="details.userNo || '-'" />
        <van-cell title="用户电话：" :value="details.mobile || '-'" />
        <van-cell title="微信昵称：" :value="details.nickName || '-'" />
        <van-cell title="健康管家：" :value="details.assistantName || '-'" />
        <van-cell
          title="添加时间："
          :value="details.addAssistantWecomTime || '-'"
        />
        <van-cell title="渠道来源：" :value="details.rootChannelName || '-'" />
        <van-field
          class="outter"
          :rules="[{ required: true, message: '请选择是否电话/语音沟通' }]"
        >
          <template #input>
            <van-cell class="required" title="是否电话/语音沟通：">
              <van-radio-group
                v-model="forms.isVoiceComm"
                direction="horizontal"
              >
                <van-radio :name="1">是</van-radio>
                <van-radio :name="0">否</van-radio>
              </van-radio-group>
            </van-cell>
          </template>
        </van-field>
        <van-field
          class="outter"
          :rules="[{ required: true, message: '请选择是否问诊' }]"
        >
          <template #input>
            <van-cell class="required" title="是否问诊：">
              <van-radio-group v-model="forms.isAsk" direction="horizontal">
                <van-radio :name="1">是</van-radio>
                <van-radio :name="0">否</van-radio>
              </van-radio-group>
            </van-cell>
          </template>
        </van-field>
        <template v-if="forms.isAsk === 0">
          <van-cell class="full required" title="未问诊原因：">
            <van-field
              type="textarea"
              v-model="forms.notAskReason"
              :rules="[{ required: true, message: '请填写未问诊原因' }]"
              :maxlength="200"
              show-word-limit
            />
          </van-cell>
          <van-field
            v-model="forms.narFollowDate"
            class="outter"
          >
            <template #input>
              <van-cell
                title="未问诊后续跟进日期："
                :value="forms.narFollowDate || '请选择'"
                is-link
                @click="onDatesShow"
              ></van-cell>
              <!-- <van-icon class="icon" name="close" v-if="forms.narFollowDate" @click.stop="forms.narFollowDate = ''" /> -->
            </template>
          </van-field>
        </template>
        <van-cell class="full" title="后续跟进情况：">
          <van-field
            type="textarea"
            v-model="forms.laterFollowSituation"
            :maxlength="200"
            show-word-limit
          />
        </van-cell>
      </van-form>
    </div>
    <div class="footer">
      <van-button size="small" @click="$router.back()">返回</van-button>
      <van-button
        type="primary"
        size="small"
        :disabled="!details.mobile || !$store.state.userInfo.extNo"
        @click="onCall"
        >呼叫</van-button
      >
      <van-button
        type="info"
        size="small"
        :disabled="!details.userNo"
        :loading="!submitable"
        @click="onSubmit"
        >保存</van-button
      >
    </div>

    <van-popup v-model="dates.show" position="bottom">
      <van-datetime-picker
        v-model="dates.active"
        type="date"
        title="选择时间"
        :min-date="dates.minDate"
        @confirm="onDatesConfirm"
        @cancel="dates.show = false"
      />
    </van-popup>
  </div>
</template>
<script>
import { timeFormat } from "@/utils/baseFormat";
import { formatTime } from "@/hooks/function";
import request from "@/utils/request";
import eventBus from "@/hooks/eventBus";
export default {
  data() {
    return {
      details: {},
      forms: {
        isVoiceComm: "",
        isAsk: "",
        notAskReason: "",
        narFollowDate: "",
        laterFollowSituation: "",
      },
      dates: {
        show: false,
        active: "",
        minDate: new Date(),
      },
      submitable: true,
    };
  },
  computed: {
    userNoComputed() {
      return this.$store.state.assistantNo;
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    async init() {
      try {
        const { data } = await request({
          method: "get",
          url: "/user-service/userServiceRecord/detailByUserNo",
          params: {
            userNo: this.$route.query.userNo,
          },
        });
        this.details = data;
        this.forms = Object.assign(this.forms, {
          isVoiceComm: data.isVoiceComm,
          isAsk: data.isAsk,
          notAskReason: data.notAskReason,
          narFollowDate: data.narFollowDate || "",
          laterFollowSituation: data.laterFollowSituation,
        });
      } catch (error) {
        console.error(error);
      }
    },
    onDatesShow() {
      this.dates.active = formatTime(this.forms.narFollowDate).date;
      this.dates.show = true;
    },
    onDatesConfirm() {
      this.forms.narFollowDate = timeFormat(this.dates.active);
      this.dates.show = false;
    },
    onCall() {
      eventBus.emit("olaDial", "", this.details.mobile);
    },
    async onSubmit() {
      if (!this.submitable) return false;
      try {
        await this.$refs.formRef.validate();
        this.submitable = false;
        await request({
          method: "post",
          url: "/user-service/userServiceRecord/save",
          data: {
            userNo: this.$route.query.userNo,
            ...this.forms,
          },
        });
        this.submitable = true;
        this.$toast("保存成功");
        this.$router.back();
      } catch (error) {
        if (Array.isArray(error) && error.length) {
          this.$toast(error[0].message);
        }
        this.submitable = true;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.reception-summary {
  height: 100vh;
  background: #fff;
  display: flex;
  flex-direction: column;
  .van-nav-bar {
    &::v-deep(.van-icon) {
      color: #999;
      font-size: 24px;
    }
    &::v-deep(.van-nav-bar__title) {
      font-weight: bold;
      font-size: 18px;
    }
    &::v-deep(.van-nav-bar__left) {
      padding-left: 10px;
    }
  }
  .form {
    flex: 1;
    overflow-y: auto;
    .van-radio-group {
      justify-content: flex-end;
      .van-radio {
        margin-right: 30px;
        &:last-child {
          margin-right: 0;
        }
      }
    }
    .van-cell {
      &.full {
        display: block;
        &::v-deep(.van-cell__value) {
          margin-left: 0;
          margin-top: 5px;
        }
        .van-field {
          border: 1px solid #ccc;
          border-radius: 6px;
        }
      }
      &.required {
        &::v-deep(.van-cell__title) {
          &::before {
            content: "*";
            color: #f00;
          }
        }
      }
    }
    .van-field {
      &.outter {
        position: relative;
        padding: 0;
        &::v-deep(.van-field__error-message) {
          padding: 0 20px;
        }
        .icon {
          font-size: 24px;
          margin-right: 15px;
          margin-left: -10px;
          color: #999;
        }
      }
    }
  }
  .footer {
    position: relative;
    z-index: 2;
    padding: 15px;
    display: flex;
    justify-content: center;
    box-shadow: 0 -10px 10px rgba(#000, 0.02);
    .van-button {
      border-radius: 4px;
      padding: 0 20px;
      margin: 0 15px;
      &:last-child {
        min-width: 120px;
      }
    }
  }
}
</style>
